/*
*@Author: lyf
*@Date: 2019-09-02 19:49:48
 * @Last Modified by: lyf
 * @Last Modified time: 2019-09-03 14:53:34
*/
Vue.component('custom-select', {
  delimiters: ['${', '}'],
  data() {
    return {
      selectShow: false
    }
  },
  props: ['list', 'value', 'placeholder', 'disabled', 'selectCallback'],
  template:
  '<div class="base-template-select">' +
    '<i class="ti-angle-down"></i>' +
    '<input class="base-template-select-input" ref="inputel" type="text" :placeholder="placeholder" @blur="selectBlur" @click="isScrollSelect" v-model="label" readonly/>' +
    '<transition name="list">' +
      '<div class="base-template-select-list" v-show="selectShow">' +
        '<div v-if="list.length===0" class="base-template-select-item">No Data</div>' +
        '<div v-else :class="selectItemClass(item.value)" v-for="(item,index) in list" :key="index" @click="setSelectData(item.value)">' +
          '${item.label}' +
        '</div>' +
      '</div>' +
    '</transition>' +
  '</div>',
  watch: {
  },
  computed: {
    label() {
      if (!this.value) return ''
      const item = this.list.filter(item => {
        return item.value == this.value
      })[0] || {}
      return item.label || ''
    }
  },
  methods: {
    selectItemClass(value) {
      let active = ''
      if (this.value == value) active = ' active'
      return 'base-template-select-item' + active
    },
    setSelectData(value) {
      console.log(value)
      if (this.disabled) return
      this.$emit("input", value);
      this.selectShow = false;
      this.selectCallback && this.selectCallback(value);
     },
    selectBlur() {
      if (this.disabled) return
      setTimeout(() => {
        this.selectShow = false;
      }, 200)
    },
    isScrollSelect() {
      if (this.disabled) return
      this.selectShow = !this.selectShow;
    },
    inputFocus() {
      this.$refs.inputel.focus();
    }
  }
})